<template>
  <wizzard-container :infos="infos">
    <div class="title">{{ $t('Business Form Social') }}</div>
    <p class="caption">{{ $t('Business Form Social Caption') }}</p>
    <v-text-field
      v-model="form.socials.facebook"
      label="Facebook"
      placeholder="https://www.facebook.com/your-page"
      outlined
      dense
      :error-messages="firstError('form.socials.facebook')"
    />
    <v-text-field
      v-model="form.socials.instagram"
      label="Instagram"
      placeholder="https://www.instagram.com/your-profile"
      outlined
      dense
      :error-messages="firstError('form.socials.instagram')"
    />
    <v-text-field
      v-model="form.socials.tiktok_handle"
      label="Tiktok handle"
      :placeholder="`@yourhandle (${$t('Example')}: @john)`"
      outlined
      dense
      :error-messages="firstError('form.socials.tiktok_handle')"
    />
    <v-text-field
      v-model="form.socials.youtube_video_id"
      :label="$t('Business Form Youtube Video Id')"
      placeholder="dQw4w9WgXcQ (YouTube video ID)"
      outlined
      dense
      :error-messages="firstError('form.socials.youtube_video_id')"
    />
    <form-action-buttons
      status="listed"
      @submit="submit"
    />
  </wizzard-container>
</template>

<script>
import axios from 'axios';
import { validationMixin } from 'vuelidate';
import { maxLength, url } from 'vuelidate/lib/validators';
import FormValidationMixin from '@/lib/FormValidationMixin';
import FormActionButtons from '@/views/ads/forms/FormActionButtons.vue';
import WizzardContainer from '@/views/ads/forms/WizzardContainer.vue';

export default {
  mixins: [validationMixin, FormValidationMixin],
  components: {
    FormActionButtons,
    WizzardContainer,
  },
  props: {
    businessId: { type: String, required: true },
    business: { type: Object, default: null },
  },
  data() {
    return {
      form: {
        socials: {
          facebook: null,
          instagram: null,
          tiktok_handle: null,
          youtube_video_id: null,
        },
      },
    };
  },
  watch: {
    business: {
      immediate: true,
      handler() {
        this.setFormData();
      },
    },
  },
  validations() {
    return {
      form: {
        socials: {
          facebook: {
            url,
            maxLength: maxLength(255),
          },
          instagram: {
            url,
            maxLength: maxLength(255),
          },
          tiktok_handle: {
            maxLength: maxLength(255),
          },
          youtube_video_id: {
            maxLength: maxLength(255),
          },
        },
      },
    };
  },
  computed: {
    infos() {
      return [
        {
          icon: 'green-energy',
          title: 'Business Form Social InfoTitle',
          description: 'Business Form Social InfoDescription',
        },
      ];
    },
  },
  methods: {
    setFormData() {
      if (!this.business) {
        return;
      }

      this.form.socials = {
        ...this.form.socials,
        ...(this.business.socials || {}),
      };
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.scrollToFirstError();
        return;
      }
      this.$store.dispatch('loading', true);
      axios
        .post(`panel/ads/validation/business/social/${this.businessId}`, this.form)
        .then(() => {
          this.$store.dispatch('clearErrors');
          this.$store.dispatch('message', this.$t('Saved successfully'));
          this.$emit('success');
        })
        .catch((error) => {
          const errors = error.response && error.response.data && error.response.data.errors
            ? error.response.data.errors
            : {};
          this.$store.dispatch('setErrors', errors);
          this.scrollToFirstError();
        })
        .finally(() => {
          this.$store.dispatch('loading', false);
        });
    },
  },
};
</script>
